#import "../CompanyConfigurationCategoriesFields.graphql"

query CompanyConfigurationCategory($id: UUID!) {
  companyConfigurationCategory(id: $id) {
       ...CompanyConfigurationCategoriesFields
    }
  }
